import {Box, BoxProps} from '@mui/material'
import React from 'react'

export const PageContainer: React.FC<BoxProps> = (props) => (
  <Box px={{xs: 1, sm: 2, md: 3, lg: 4}} py={{xs: 2, md: 3}} {...props} />
)
